<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/exportLog')">导出任务记录</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
        <div class="contain_header clr">
            <el-form
              :inline="true"
              class="m-search"
              size='small'
              :model="filters"
            >

            <el-form-item>
              <el-button
                type="primary"
                @click="getLog()"
              >刷新</el-button>
  
  
            </el-form-item>
  
          </el-form>
        </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div> -->
        <el-table
          ref="dataTable"
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="username"
            label="姓名"
          >
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="手机号"
          >
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="导出时间"
          >
          </el-table-column>

          <el-table-column
            prop="updateTime"
            label="完成时间"
          >
          </el-table-column>

          <el-table-column
            prop="exportType"
            label="文件类型"
          >
            <template slot-scope='scope'>
              <div>{{formatterExportType(scope.row)}}</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="status"
            label="状态"
          >
            <template slot-scope='scope'>
              <div>{{formatterStatus(scope.row)}}</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="exportUrl"
            label="附件"
          >
            <template slot-scope='scope'>
              <div v-if="scope.row.status == 2 && scope.row.exportUrl">
                <el-button type="primary" @click="getExportUrl(scope.row.exportUrl)">下载</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>
  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "userInData",
  created() {},
  data() {
    return {
      totalMoney: 0,
      userList:[],
      subListVisible: false,
      listLoading: false,
      picList: [],
      askRoleType: null,
      filters: {
        userId: null,
        startTime: null,
        endTime: null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      detailListLoading: false,
      tableDetailData: [],
      tableHeight: null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.getLog()

  },
  methods: {
    getLog(){
      let that = this;
      that.listLoading = true;
      let para = {
        token: localStorage.getItem("api_token"),
        pageNum: that.page_num,
        pageSize: that.page_size
      };
      API.export_log_list(para)
        .then(
          function(result) {
            if (result && parseInt(result.key) === 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list != null && result.result.list.length > 0) {
                for(var i = 0;i<result.result.list.length;i++){
                  result.result.list[i].createTime = dateFunc.formatDate(
                      new Date(result.result.list[i].createTime),
                      "yyyy-MM-dd hh:mm:ss"
                    );
                    if(result.result.list[i].updateTime){
                        result.result.list[i].updateTime = dateFunc.formatDate(
                        new Date(result.result.list[i].updateTime),
                        "yyyy-MM-dd hh:mm:ss"
                      );
                    }
                    
                }
                that.tableData = result.result.list;
              } else {
                that.tableData = [];
              }
              that.listLoading = false
            }
          },
          function(err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    getExportUrl(url){
      window.open(url,'_blank')
    },
    formatterStatus(row, column) {
      if (row.status == 1) {
        return "运行中";
      } else if (row.status == 2) {
        return "可下载";
      } else if (row.status == 3) {
        return "运行失败";
      }
    },
    formatterExportType(row, column) {
      if (row.exportType == 1) {
        return "通联余额";
      } else if (row.exportType == 2) {
        return "代理库存价值";
      } else if (row.exportType == 3) {
        return "代理库存明细";
      } else if (row.exportType == 4) {
        return "待补货明细";
      }
    },
    goDown(){
      this.$refs.dataTable.bodyWrapper.scrollTop =this.$refs.dataTable.bodyWrapper.scrollHeight;
    },
    goTop(){
      this.$refs.dataTable.bodyWrapper.scrollTop =0;
    },
    showDetailInfos(row) {
      if (!this.filters.endTime || this.filters.endTime == null || !this.filters.startTime || this.filters.startTime == null || !this.filters.userId || this.filters.userId == null)
      {
        this.$message.error({
            showClose: true,
            message: "请检查下时间或者总经销商是否都已经选择好",
            duration: 2000
          });
      } else
      {
        let that = this;
        that.subListVisible = true;
        this.page_size = 10;
        this.page_num = 1;
        this.searchDetail();
      }

    },
    searchDetail() {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        orderType: 1,
        status: 22,//查询已自提+发货已完成的
        pageNum: that.page_num,
        pageSize: that.page_size
      };
      if (that.filters.startTime) {
        para.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        para.endTime = that.filters.endTime.getTime();
      }
      that.detailListLoading = true;
      API.order_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num = result.result.count;
            that.total_page = result.result.allPageNumber;


              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  if (result.result.list[i].send_time != null)
                  {
                    result.result.list[i].send_time1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].send_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  }
                }
              }
              that.tableDetailData = result.result.list;
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    excelOutUserDistrict(){
      var that = this;
      var url =
        "/manager/user/pc/app_user_District_balance_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.startTime) {
        url = url + "&beginTime=" + that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.userId) {
        url = url + "&userId=" + that.filters.userId;
      // } else
      // {
      //   that.$message.error({
      //       showClose: true,
      //       message: "请先选择经销商",
      //       duration: 2000
      //     });
      //   return;
      }
      top.location.href = url;
    },
    excelOut(type) {
      var that = this;
      var url =
        "/manager/user/pc/send_head_num_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (type == 1)
        {
      if (that.filters.userId) {
        url = url + "&userId=" + that.filters.userId;
      } else
      {

          that.$message.error({
            showClose: true,
            message: "请先选择经销商",
            duration: 2000
          });
        return;

      }}
      top.location.href = url;
    },
    handleSearch() {
      this.search();
    },
    formatterRoleType(row, column) {
      if (row.role_type == 0) {
        return "VIP门店";
      } else if (row.role_type == 1) {
        return "联盟店";
      } else if (row.role_type == -0.5) {
        return "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        return "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        return "康减系列荣誉会员";
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 3) {
        return "省代";
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      }  else if (row.role_type == 4.8) {
        return "经销商";
      }
    },

    search() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token")
      };
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先选择时间",
            duration: 2000
          });
        return;
      }

      if (that.filters.userId != null) {
        params.userId = that.filters.userId;
      } else
      {
        that.$message.error({
            showClose: true,
            message: "请先总经销商",
            duration: 2000
          });
        return;
      }
      that.listLoading = true;
      API.send_head_num(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                that.tableData = result.result.list;
                that.totalMoney = result.result.map.totalM;
              } else {
                that.tableData = [];
              }
              console.info(that.tableData)
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.getLog(this.askRoleType);
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/exportLog.vue